import { render, staticRenderFns } from "./MgidCategoriesDropdown.vue?vue&type=template&id=478d83ec"
import script from "./MgidCategoriesDropdown.vue?vue&type=script&lang=js"
export * from "./MgidCategoriesDropdown.vue?vue&type=script&lang=js"
import style0 from "./MgidCategoriesDropdown.vue?vue&type=style&index=0&id=478d83ec&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports